import { NetworkPathPositionOptionDto } from '@connect-services/src/sdk/api';

export type NetworkPathSelection =
    | {
          type: NetworkPathSelectionType.ALL;
      }
    | {
          item: NetworkPathPositionOptionDto;
          type: NetworkPathSelectionType.ROUTE;
      };

export enum NetworkPathSelectionType {
    ALL = 'all',
    ROUTE = 'route',
}
